import { useSingleton } from "../../other/injection";
import { AppTimerService } from "../../other/timer/AppTimerService";
import { LoggedInUserStore } from "../../other/loggedInUser/LoggedInUserStore";
import { observer } from "mobx-react-lite";
import { BannerPage } from "../../uiLibrary/bannerPage/BannerPage";
import { RouteStore } from "../../other/navigationAndRouting/RouteStore";
import {
    mainNavRoutes,
    settingsRoute
} from "../../other/navigationAndRouting/routes";
import { useMemo } from "react";
import { BigRouteList } from "../../uiLibrary/bigRouteList/BigRouteList";
import { PriorityCases } from "./PriorityCases";
import { InternalMediaHomePageInsert } from "../internalMedia/InternalMediaHomePageInsert";

export const HomePage = observer(() => {
    const timer = useSingleton(AppTimerService);
    // eslint-disable-next-line no-console
    console.log("home", timer.timeInMs());

    const loggedInUserStore = useSingleton(LoggedInUserStore);
    const routeStore = useSingleton(RouteStore);

    const allRoutes = useMemo(() => [...mainNavRoutes, settingsRoute], []);
    const routes = routeStore.getMenuRoutes(allRoutes);

    const showInternalMedia = loggedInUserStore.splits?.BettermodeVisible;

    {
        /* Priority Cases are only shown to non-mifid users */
    }
    const showPriorityCases = !loggedInUserStore.hasProduct(
        RedDeer.Contracts.Enums.ProductType.Mifid
    );

    return (
        <BannerPage
            title={`Welcome back ${loggedInUserStore.forename}`}
            slim={true}
        >
            <div className="flex flex-wrap">
                {showPriorityCases && (
                    <div className="md:w-full lg:w-[50%]">
                        <PriorityCases />
                    </div>
                )}
                {showInternalMedia !== undefined && (
                    <div className="md:w-full lg:w-[50%]">
                        {showInternalMedia ? (
                            <InternalMediaHomePageInsert />
                        ) : (
                            <BigRouteList routes={routes} testId="homeLinks" />
                        )}
                    </div>
                )}
            </div>
        </BannerPage>
    );
});
